import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './TransaksiReferensiHutang.service'
import KategoriPPh25Service from '../../adminpajakku/kategoriPph25/KategoriPph25.service'
import TipePengecualianPajakService from '../../adminpajakku/tipePengecualianPajak/TipePengecualianPajak.service'
import Utils from '../../../libs/custom/Utils'
import AkunService from '../../master/Akun/Akun.service'
import KodeObjekPajakService from '../../adminpajakku/KodeObjekPajak/KodeObjekPajak.service'
import TransaksiService from './Transaksi.service'
import { AKUN_JENIS_MAP } from '../../../clientConstant'


const TransaksiReferensiHutangForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [isEdit, setIsEdit] = useState(false)
  const [data, setData] = useState({loading: true, content: {}})
  const [akunList, setAkun] = useState([])
  const [journalMap, setJournalMap] = useState({})
  const [kodeObjekPajakList, setKodeObjekPajak] = useState([])

  // initial data
  useEffect(() => {
    async function initData() {
      _getAkun()
      _getKodeObjekPajak()
      if(match.params.id == 'baru') {
        setData({loading: false, content: {dipungut: false, dpp:'0', pph: '0', transaksiReferensiHutangAkun__nilai: '0', transaksiBebanPromosiPengecualians: []}})
        return true
      }
      const res = await service.getOne(match.params.id)
      res.data = Utils.formSerialize(res.data)
      // res.data.transaksiReferensiHutangAkun__akunid = res.data.transaksiReferensiHutangAkun.akun.id
      setIsEdit(true)
      setData({loading: false, content:res.data})
    }
    initData()
  }, ['match.params.id'])

  async function _getAkun() {
    var res = await TransaksiService.getOne(match.params.transaksiId)
    setJournalMap(res.data.transaksiJurnals.reduce((pv, cv)=> {
      pv[cv.id] = cv
      return pv
    }, {}))
    setAkun(res.data.transaksiJurnals)
  }

  async function _getKodeObjekPajak() {
    var res = await KodeObjekPajakService.get({size: 100000})
    setKodeObjekPajak(res.data.map(x => ({value: x.id, label: x.nama})))
  }

  return (
    <FormWrapper
      noValidate
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={'/onpremise/transaksi/'+match.params.transaksiId+'/referensi-hutang'}
      baseId="mod-form-sample"
      title='Referensi Hutang'
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      onChange={(newObj, key, value, parentKey, indexAtParent) => {
        if(key == 'jurnal__id') {
          newObj.jurnal__nilai = journalMap[value].nilai
          newObj.nilai = journalMap[value].nilai
        }
      }}
      definitions={[
        // =====
        {
          inputType: inputTypes.DIVIDER,
          label: '# AKUN TRANSAKSI'
        },
        {
          inputType: inputTypes.SELECT,
          label: 'Akun',
          key: 'jurnal__id',
          type: 'text',
          width: '49%',
          required: true,
          validation: 'required',
          options: akunList.filter(x => x.akun.akunJenisId == AKUN_JENIS_MAP["Akun Hutang Lainnya"].id).map(x => ({value: x.id, label: x.akun.nama})),
          style: {marginRight: '2%'}
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Nilai',
          key: 'jurnal__nilai',
          // theme: 'filled',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          width: '49%',
          disabled: true,
          validation: 'required|numeric'
        },
        {
          inputType: inputTypes.DIVIDER,
          label: '# DETAIL REFERENSI HUTANG'
        },
        {
          inputType: inputTypes.INPUT,
          label: 'Nomor Referensi Hutang',
          key: 'nomor',
          type: 'text',
          width: '100%',
          validation: 'required'
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Nilai',
          key: 'nilai',
          // theme: 'filled',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          width: '49%',
          style: {marginRight: '2%'},
          validation: 'required|numeric'
        },
        {
          inputType: inputTypes.DATEPICKER,
          label: 'Tanggal Jatuh Tempo',
          key: 'tanggalJatuhTempo',
          width: '49%',
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          var tglTransaksi = JSON.parse(localStorage.getItem("tgl"))
          data.transaksiId = match.params.transaksiId
          data = Utils.formNormalize(data)
          var allres = await service.get({'transaksiId.equals': data.transaksiId, size: 100000});
          var total = allres.data.filter(x => x.id != data.id).reduce((pv, cv)=> {
            pv = pv+parseInt(cv.nilai);
            return pv
          }, 0)

          total = total + parseInt(data.nilai)
          // console.log(journalMap, data.transaksiJurnal__id,'asdasd')
          var akunId = journalMap[data.jurnal__id].akun.id

          var totalJurnal = akunList.reduce((pv, cv)=> {
            if(cv.akun.id == akunId) {
              pv = pv+parseInt(cv.nilai)
            }
            return pv
          }, 0)


          if(total > totalJurnal) {
            // iziToast.warning({message: 'Total nilai beban promosi melebihi nilai jurnal'})
            callback('Total Nilai Hutang yang dimasukkan melebihi nilai Akun Transaksi Hutang', true, false)
            return false
          }

          if(data.tanggalJatuhTempo <= tglTransaksi) {
            // iziToast.warning({message: 'Total nilai beban promosi melebihi nilai jurnal'})
            callback('Tanggal jatuh tempo tidak boleh lebih kecil dari tanggal transaksi', true, false)
            return false
          }

          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/transaksi/'+match.params.transaksiId+'/referensi-hutang')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(TransaksiReferensiHutangForm))
